<template>
  <div ref="control" :class="['control', { error: error && error.length }, { success: valid }]">
    <div class="control-wrap">
      <select
        @change="select"
        v-model="val"
        ref="select"
        class="control-input"
        :value="value"
        :label="label"
        :name="name"
        :v-validate="validate"
        :id="id"
        :disabled="disabled"
      >
        <option :value="null">{{ label }}</option>
        <option v-for="(option, index) in this.options" :key="index" :value="option.slug">
          {{ option.name }}
        </option>
      </select>
      <font-awesome-icon class="control-icon control-icon--right" :icon="['fas', 'caret-down']" />
    </div>

    <p class="control-error" v-if="error && error.length">{{ error[0] }}</p>
  </div>
</template>

<script>
export default {
  name: 'FormControlSelect',
  data() {
    return {
      states: {},
      isValid: false,
      val: null
    };
  },
  $_veeValidate: {
    value() {
      return this.val;
    },
    name() {
      return this.name;
    }
  },
  props: [
    'label',
    'options',
    'id',
    'value',
    'item',
    'name',
    'valid',
    'validate',
    'error',
    'disabled'
  ],
  methods: {
    select() {
      this.$emit('input', this.$refs.select.value ? this.$refs.select.value : null);
    }
  },
  mounted() {
    this.val = this.value;
  },
  watch: {
    value(newVal) {
      this.val = newVal;
      const field = this.$parent.$validator.fields.find({ name: this.name });
      if (field) {
        field.setFlags({ dirty: true });
        this.$parent.$validator.validate(this.name);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.control-icon {
  color: var(--color-positive);
}
</style>
